import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import BirdFlock from 'react-bird-flock';
import BodySubSection from '../../components/body-section/BodySection';
import Seo from '../../utils/seo';

const Home: React.FC = (): ReactElement => {
  return (
    <>
      <Seo
        pageTitle="Oluwasegun Adepoju | Software Engineer"
        description="Software engineer building modern digital products, interfaces, and scalable web experiences."
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: 'Oluwasegun Adepoju',
          jobTitle: 'Software Engineer',
          url: 'https://segunadepoju.com/',
          sameAs: [
            'https://github.com/oluwasegun-aa',
            'https://www.linkedin.com/in/adepoju/',
          ],
        }}
      />
      <section className="page_view" style={{ position: 'relative' }}>
        {/* Background birds layer */}
        <BirdFlock
          count={12}
          size={30}
          zIndex={1}
          topSpeed={3}
          perchDelaySeconds={2}
        />

        <div className="page_inner page_inner--narrow">
          <div
            className="centreBody"
            style={{ position: 'relative', zIndex: 0.5 }}
          >
            <BodySubSection
              className="info"
              centerPane={
                <div>
                  <div className="name">Olúwáṣẹ́gun</div>
                  <div className="title">Software Engineer</div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <Link className="home_explorations_cta" to="/work">
                      Trail of Efforts
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        aria-hidden="true"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </Link>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
